import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { BookOpen, ArrowRight, Quote } from "lucide-react";
import { courseModules, courseStats } from "../mock";

const FinanceCourseSection = () => {
  const preview = courseModules.slice(0, 4);

  return (
    <section
      id="finance"
      className="relative bg-[#04181a] py-20 md:py-28 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 20%, #14b8a6 0%, transparent 45%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 bg-teal-500/10 border border-teal-400/30 text-teal-200 px-3 py-1.5 rounded-full text-xs tracking-wide">
              <BookOpen className="w-3.5 h-3.5" />
              <span>Biblical Finance Course · Free for members</span>
            </div>
            <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05]">
              Money,{" "}
              <em className="text-teal-300 font-serif font-normal">
                rooted in scripture.
              </em>
            </h2>
            <p className="mt-5 text-white/65 text-lg max-w-2xl">
              An 8-module course built on biblical principles — stewardship,
              tithing, debt freedom, credit, generosity, and the call to
              entrepreneurship. Practical workbooks. Real accountability.
            </p>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-px rounded-xl overflow-hidden border border-white/10 bg-white/10">
            {courseStats.map((s) => (
              <div key={s.label} className="bg-black/60 p-5">
                <div className="text-3xl font-semibold text-teal-300 tracking-tight">
                  {s.value}
                </div>
                <div className="mt-1 text-white/60 text-xs uppercase tracking-wide">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {preview.map((m) => (
            <article
              key={m.id}
              className="group rounded-2xl border border-white/10 bg-white/[0.03] p-7 hover:border-teal-400/40 hover:bg-white/[0.05] transition-all"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="text-xs font-mono text-teal-300">
                    Module {m.number}
                  </div>
                  <h3 className="mt-1 text-xl md:text-2xl font-semibold text-white">
                    {m.title}
                  </h3>
                </div>
                <div className="text-xs text-white/50 whitespace-nowrap">
                  {m.lessons} lessons · {m.duration}
                </div>
              </div>
              <div className="mt-4 flex items-start gap-2 text-teal-200/90 text-sm border-l-2 border-teal-400/40 pl-3">
                <Quote className="w-3.5 h-3.5 mt-1 text-teal-400/60" />
                <span>
                  <strong className="font-semibold">{m.verse}</strong> —{" "}
                  <em className="font-serif">{m.verseText}</em>
                </span>
              </div>
              <p className="mt-4 text-white/65 leading-relaxed text-sm">
                {m.summary}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl border border-teal-400/20 bg-teal-500/[0.04] p-6">
          <div className="text-white/80">
            See all 8 modules — from stewardship to legacy.
          </div>
          <Link to="/finance-course">
            <Button className="bg-teal-400 hover:bg-teal-300 text-black font-semibold h-11 px-6">
              Open the full course
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinanceCourseSection;
